import { render, staticRenderFns } from "./editSeller.vue?vue&type=template&id=166db758&scoped=true&"
import script from "./editSeller.vue?vue&type=script&lang=js&"
export * from "./editSeller.vue?vue&type=script&lang=js&"
import style0 from "./editSeller.vue?vue&type=style&index=0&id=166db758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166db758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VChip,VCombobox,VContainer,VFlex,VForm,VIcon,VLayout,VSelect,VTextField})
